/**
 * @module components\ghInput\textAreaInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";

@Component
export default class TextAreaInput extends InputBase {}
